module.exports = __webpack_public_path__ + "img/ok.ffa2ddbf.png";